/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// actions
import {
    GET_ADDONS,
    GET_CODE,
    DISCARD_ADDONS_SETTINGS,
    ADDONS_SETTINGS_CHANGED,
    UPDATE_ADDONS_SETTING_SUCCESS,
    UPDATE_ADDONS_SETTING_ERROR
} from 'state/actions/ratingsState/addOnsStatus';



/* ========== ~~~~~~~~~~ ADDONS STATE > ADDONS STATUS: REDUCER ~~~~~~~~~~ ========== */

// ^-^ ^-^ ^-^ ^-^ ^-^   DEFAULT STATE   ^-^ ^-^ ^-^ ^-^ ^-^ //

const defaultState = {
    addOnsData: {
        counterConfiguration: {
            uuid: "dfae44b4-14a1-4122-927f-e0a00b04fdfb",
            zeroRatingLabel: "No ratings",
            oneRatingLabel: "1 rating",
            multipleRatingsLabel: "2 ratings",
            showHalfStars: false,
            enabled: true
        },  
    },
    previouslySavedData: null,
    isAddOnsSettingsChanged: false,
    getAddOnsError: false,
    isAddOnsSettingsUpdated: false,
    previousSelectedSiteUUID: 'site2',
    code: {
      headerCode: '',
      ratingCounterCode: ''
    }
};


// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const addOnsStatus = (state = defaultState, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case GET_ADDONS:
          Object.keys(action.data).forEach(property => {
            if(newState.addOnsData.hasOwnProperty(property)) {
              newState.addOnsData[property] = action.data[property];
            }
          });
          newState.previouslySavedData = newState.addOnsData;
          newState.previousSelectedSiteUUID = action.siteUUID;
          newState.isAddOnsSettingsChanged = false;
          return newState;
        case GET_CODE:
          newState.code = action.data;
          return newState;
        case DISCARD_ADDONS_SETTINGS:
            if(!newState.isAddOnsSettingsUpdated) {
                newState.addOnsData = newState.previouslySavedData;
            }
            newState.addOnsData[action.addOnsType][action.ignoreProperty.name] = action.ignoreProperty.value;
            newState.isAddOnsSettingsChanged = false;
            return newState;
        case ADDONS_SETTINGS_CHANGED:
            newState.isAddOnsSettingsUpdated = false;
            if(action.addOnsType) {
                newState.addOnsData[action.addOnsType][action.property] = action.value;
            } else {
                newState[action.property] = action.value;
            }
            if(JSON.stringify(newState.previouslySavedData) != JSON.stringify(newState.addOnsData))
              newState.isAddOnsSettingsChanged = true;
            else
              newState.isAddOnsSettingsChanged = false;
            return newState;
        case UPDATE_ADDONS_SETTING_SUCCESS:
            newState.isAddOnsSettingsUpdated = true;
            newState.isAddOnsSettingsChanged = false;
            newState.previouslySavedData = newState.addOnsData;
            newState.addOnsData = newState.addOnsData;
            return newState;
        case UPDATE_ADDONS_SETTING_ERROR:
            newState.isAddOnsSettingsUpdated = false;
            newState.addOnsData = newState.previouslySavedData;
            return newState;
        default:
            return state;
    }
};

/* ++++++++++ --------------- CUSTOM METHODS --------------- ++++++++++ */


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default addOnsStatus;
